import { render, staticRenderFns } from "./InitialStocks.vue?vue&type=template&id=c4bc1dc6"
import script from "./InitialStocks.vue?vue&type=script&lang=js"
export * from "./InitialStocks.vue?vue&type=script&lang=js"
import style0 from "./InitialStocks.vue?vue&type=style&index=0&id=c4bc1dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports